module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Puos8K/tc-custom/FC-9781528985925.jpg?1685204506728?1725650127533",
      "alt": "This image is the cover for the book For Bravery in the Field"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("For Bravery in the Field\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam commodo pharetra velit non malesuada. Aenean eleifend nunc quis ex cursus fermentum. Nulla aliquet orci viverra velit tincidunt pulvinar. Proin pulvinar, arcu ut tempor bibendum, ipsum massa sodales metus, id mollis sem risus eget massa. Mauris volutpat maximus risus sed posuere. Donec pharetra, velit et euismod mattis, elit nunc feugiat urna, et ultrices lacus ante quis nisl. Etiam rutrum mi ut leo viverra convallis. Mauris maximus posuere purus vitae facilisis. Quisque ac velit ac mi eleifend malesuada nec vitae nulla. Vestibulum varius, lacus eget maximus iaculis, risus dolor laoreet eros, vitae aliquam metus erat eget tortor. Nulla congue nisl eu justo porta, a condimentum magna pharetra. Vestibulum lacus urna, commodo at pretium at, facilisis vel justo. Sed et efficitur ipsum. Fusce non lectus nec arcu vestibulum scelerisque eget tempor tellus. Duis posuere interdum lectus, non tincidunt metus maximus semper. Proin eu sollicitudin sapien.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stuart Fox\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0